<template>
  <div class="iDalgo-Stats">
    <i-dalgo-stat
      v-if="stats.nAge"
      :value="stats.nAge"
      :unit="units.nAge"
      :subTitle="subTitles.nAge"
      :svg="svg.nAge"
      />
    <i-dalgo-stat
      v-if="stats.nHeight"
      :value="stats.nHeight"
      :unit="units.nHeight"
      :subTitle="subTitles.nHeight"
      :svg="svg.nHeight"
      />
    <i-dalgo-stat
      v-if="stats.nWeight"
      :value="stats.nWeight"
      :unit="units.nWeight"
      :subTitle="subTitles.nWeight"
      :svg="svg.nWeight"
      />
    <i-dalgo-stat
      v-if="stats.nCompetition"
      :value="stats.nCompetition"
      :unit="units.nCompetition"
      :subTitle="competition.tName"
      :image="competition.tUrlPicture"
      />
  </div>
</template>

<script>
import iDalgoStat from '@/components/iDalgo-Stat'
import { mapGetters } from 'vuex'

export default {
  name: 'iDalgo-Stats',
  components: {
    iDalgoStat
  },
  computed: {
    ...mapGetters({
      stats: 'results/getUserPlayersMiddleStats',
      competition: 'results/getCompetition'
    }),
    defaultStats () {
      const data = {}
      Object.keys(this.stats).forEach(key => {
        if (key !== 'nCompetition') {
          data[key] = this.stats[key]
        }
      })
      return data
    }
  },
  data () {
    return {
      svg: {
        nAge: 'heart',
        nHeight: 'height',
        nWeight: 'weight'
      },
      units: {
        nAge: this.$t('stats.units.nAge'),
        nHeight: this.$t('stats.units.nHeight'),
        nWeight: this.$t('stats.units.nWeight'),
        nCompetition: '%'
      },
      subTitles: {
        nAge: this.$t('stats.subtitles.nAge'),
        nHeight: this.$t('stats.subtitles.nHeight'),
        nWeight: this.$t('stats.subtitles.nWeight')
      }
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Stats {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Stats.vue